import type { HTMLAttributes } from "react";

import { BreakpointProp } from "@/ui/lib";
import { DefinedDefaults } from "@/ui/lib/types";

/*-------------------------------------
|  Constants
|-------------------------------------*/
export const AVAILABLE_COLUMN_TAGS = [ "div", "li", "ol" ] as const;

export const COLUMN_SPANS_CLASS_MAP = {
  "12": "col-span-12",
  "11": "col-span-11",
  "10": "col-span-10",
  "9": "col-span-9",
  "8": "col-span-8",
  "7": "col-span-7",
  "6": "col-span-6",
  "5": "col-span-5",
  "4": "col-span-4",
  "3": "col-span-3",
  "2": "col-span-2",
  "1": "col-span-1",
} as const;

export const COLUMN_RESPONSIVE_SPANS_CLASS_MAP = {
  default: COLUMN_SPANS_CLASS_MAP,
  xl: {
    "12": "xl:col-span-12",
    "11": "xl:col-span-11",
    "10": "xl:col-span-10",
    "9": "xl:col-span-9",
    "8": "xl:col-span-8",
    "7": "xl:col-span-7",
    "6": "xl:col-span-6",
    "5": "xl:col-span-5",
    "4": "xl:col-span-4",
    "3": "xl:col-span-3",
    "2": "xl:col-span-2",
    "1": "xl:col-span-1",
  },
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

type TColumnTag = typeof AVAILABLE_COLUMN_TAGS[number];

export type TColumnSpans = keyof typeof COLUMN_SPANS_CLASS_MAP;

export type TColumSpansProp =
  BreakpointProp<typeof COLUMN_RESPONSIVE_SPANS_CLASS_MAP>;

export type TColumnProps = {
  tag?: TColumnTag,
  spans?: TColumSpansProp;
} & HTMLAttributes<HTMLElement>;

type TColumnDefaultProps = DefinedDefaults<
  TColumnProps,
  "spans" | "tag"
>;

/*-------------------------------------
|  Defaults
|-------------------------------------*/

export const COLUMN_DEFAULTS = {
  tag: "div",
  spans: "12",
} satisfies TColumnDefaultProps;
